<script>
    import AnimationsMixin from "../../../author/pagesbuilder/mixins/AnimationsMixin";

    export default {
        name: "ContactFormElement",
        mixins: [
            AnimationsMixin,
        ],
        data() {
            return {
                givesContextToChildren: true,
                elementType: 'contact-form',
            }
        },
        created() {
            this.addListeners();
        },
        methods: {
            addListeners() {
                // overridden
            },
        }
    }
</script>
